import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

/**
 * Test S&S API connection
 */
const testConnection = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_URL + "/admin/sands/test",
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

/**
 * Load all styles from S&S
 */
const loadAllStyles = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_URL + "/admin/sands/loadAllStyles",
    { headers: AuthHeader.authHeader(), timeout: 60 * 60 * 1000 }
  );
  return response.data;
};

/**
 * Load products for every S&S style already in the database
 */
const loadAllProducts = async () => {
  const response = await axios.get(
    process.env.REACT_APP_API_URL + "/admin/sands/loadAllProducts",
    { headers: AuthHeader.authHeader(), timeout: 60 * 60 * 1000 }
  );
  return response.data;
};

/**
 * Load a single style from S&S by alphabroder partNumber
 */
const loadStyleByPartNumber = async (partNumber) => {
  const response = await axios.get(
    process.env.REACT_APP_API_URL + "/admin/sands/loadStyle/" + encodeURIComponent(partNumber),
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const loadProductsByPartNumber = async (partNumber) => {
  const response = await axios.get(
    process.env.REACT_APP_API_URL + "/admin/sands/loadProducts/" + encodeURIComponent(partNumber),
    { headers: AuthHeader.authHeader() }
  );
  return response.data;
};

const SandsService = {
  testConnection,
  loadAllStyles,
  loadAllProducts,
  loadStyleByPartNumber,
  loadProductsByPartNumber
};

export default SandsService;

